import {css} from '@isceco/widget-library2/external/lit'

export default css`
  :host {
    display: block;
    --border-color: var(--isceco-color-grey-700);
  }

  .popup {
    position: relative;
    color: var(--isceco-color-black-500);
    border: 2px solid var(--border-color);
    background-color: var(--isceco-color-white-500);
    padding: var(--isceco-space-100);
    border-radius: var(--isceco-space-100);
  }

  .popup.hidden {
    opacity: 0;
  }

  slot {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .line {
    position: fixed;
    border: none;
    z-index: 1;
    pointer-events: none;
  }

  /* helpText spezifisch */

  .helptext {
    position: absolute;
    top: 0;
    right: 50%;
    pointer-events: none;
  }
`
